import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {DropdownWithTitleComponent} from './components/dropdown-with-title.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [DropdownWithTitleComponent], // module components
  exports: [DropdownWithTitleComponent]
})
export class DropdownWithTitleModule {
}
